import React from "react";
import ReactDiffViewer, { DiffMethod } from "react-diff-viewer-continued";

export const diffStyles = {
  variables: {
    dark: {
      diffViewerBackground: "#1e1e1e",
      diffViewerColor: "#d4d4d4",
      // Line-level backgrounds: subtle tint across the whole changed line.
      addedBackground: "#294436",
      addedColor: "#d4d4d4",
      removedBackground: "#442c2e",
      removedColor: "#d4d4d4",
      // Word-level backgrounds: stronger highlight on the exact changed tokens.
      wordAddedBackground: "#3a7a3a",
      wordRemovedBackground: "#8b3a3f",
      addedGutterBackground: "#22392e",
      removedGutterBackground: "#3a2528",
      gutterBackground: "#1e1e1e",
      gutterBackgroundDark: "#181818",
      highlightBackground: "#2a2d2e",
      highlightGutterBackground: "#2a2d2e",
      codeFoldGutterBackground: "#252526",
      codeFoldBackground: "#252526",
      emptyLineBackground: "#1e1e1e",
      gutterColor: "#858585",
      addedGutterColor: "#81c995",
      removedGutterColor: "#f28b82",
      codeFoldContentColor: "#8a8a8a",
      diffViewerTitleBackground: "#252526",
      diffViewerTitleColor: "#cccccc",
      diffViewerTitleBorderColor: "#333333",
    },
  },
  contentText: {
    fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, monospace",
    fontSize: "0.8125rem",
  },
  wordDiff: {
    padding: "0 1px",
    borderRadius: "2px",
  },
  diffContainer: {
    borderRadius: "0.25rem",
  },
};

const DiffViewer = ({
  oldContent,
  newContent,
  selectedVersionNumber,
  comparisonVersionNumber,
}) => {
  const leftVersionText = `Version ${selectedVersionNumber || "Latest"}`;
  const rightVersionText = `Version ${comparisonVersionNumber || "Latest"}`;

  return (
    <div className="bg-gray-800 border border-gray-700 rounded p-2 overflow-auto max-h-[400px]">
      <div className="text-sm text-yellow-400 mb-2 px-1">
        Comparing {leftVersionText} with {rightVersionText}
      </div>
      <ReactDiffViewer
        oldValue={oldContent || ""}
        newValue={newContent || ""}
        splitView={true}
        useDarkTheme={true}
        compareMethod={DiffMethod.WORDS}
        showDiffOnly={false}
        leftTitle={leftVersionText}
        rightTitle={rightVersionText}
        styles={diffStyles}
      />
    </div>
  );
};

export default DiffViewer;
